import React, { Component } from 'react';
import { post, get } from '../custom_libraries/serverRequests';
import globalVariables from '../custom_libraries/globalVariables';
import { Link } from 'react-router-dom';
import './adminDash.css';
import urls from '../custom_libraries/urls';
import BackArrow from '../assets/icons8-back-arrow.gif';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import Backdrop from '@mui/material/Backdrop';
// import CircularProgress from '@mui/material/CircularProgress';
import withNavigate from '../Global_files/WithNavigate'; 
import WebLogo from '../assets/Artboard 1Bonus.png';
import passwordEye from '../assets/icons8-eye-64.png';

class DealerRegistration extends Component {

    constructor(props) {
        super(props);
        this.state = {
        user_type: 'DealerUser',
        user_name: '',
        dealer_email:'',
        dealer_password:'',
        conf_dealer_pass:'',
        first_name:'',
        last_name:'',
        mob_num:'',
        warning: false,
        warning1: false,
        warning2: false,
        warning3: false,
        success: false,
        error:false,
        open_progress_bar: false,
        passwordShown:false,
        confPasswordShown:false
          
        };
      }

      componentDidUpdate(prevProps, prevState) {
        if (
            this.state.warning !== prevState.warning ||
            this.state.error !== prevState.error ||
            this.state.warning2 !== prevState.warning2 ||
            this.state.warning1 !== prevState.warning1 ||
            this.state.warning3 !== prevState.warning3 ||
            this.state.success !== prevState.success
        ) {
            if (
                this.state.warning ||
                this.state.error ||
                this.state.warning1 ||
                this.state.warning2 ||
                this.state.warning3 ||
                this.state.success
            ) {
                setTimeout(() => {
                    this.setState({
                        warning: false,
                        error: false,
                        warning1: false,
                        warning2: false,
                        warning3: false,
                        success: false,
                    });
                }, 2500); // 1 second
            }
        }
    }
    

    
jsonData = () => {

    let data = {
      // "user_type":"DealerUser",
      // "username": this.state.user_name,
      // "email": this.state.dealer_email,
      // "password1": this.state.dealer_password,
      // "password2": this.state.conf_dealer_pass,
      // "user_type": "DealerUser",
      // "first_name": this.state.first_name,
      // "last_name": this.state.last_name,
      // "phoneno": this.state.mob_num,
      // "admin_email": this.state.dealer_email

      "user_type":"DealerUser",
      "username": this.state.user_name,
      "email": this.state.dealer_email,
      "password1": this.state.dealer_password,
      "password2": this.state.conf_dealer_pass,
      // "user_type": "DealerUser",
      "first_name": this.state.first_name,
      "last_name": this.state.last_name,
      "phoneno": this.state.mob_num,
      "admin_email":this.state.dealer_email,
  
    }
    console.log("-----JSON DATA -------->",data)
    return JSON.stringify(data)
  }
    
  // InsertDealerRegistrationInfo = async () => {
  //   this.startLoading()
  //   //let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
  //   // let dealer_email = localStorage.getItem(globalVariables.DEALER_EMAIL)
  //      //   console.log("----------access_tocken in insertTechRegistrationInfo----------",access_tocken)
  //         // console.log("----------dealer_email in insertTechRegistrationInfo----------",dealer_email)
  //     // let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
  //     // console.log("--------auth tocken---------", access_tocken);
  //     let headers = {
  //         'content-type': 'application/json',
  //         // 'Authorization': `Bearer ${access_tocken}`
  //     }
    
  //   let post_data = this.jsonData()

  //   console.log("post_data in insertCreateTicketInfo---------->",post_data)

  //   // Parse the JSON string into an object
  //   let postDataObj = JSON.parse(post_data);

  //   for (const key in postDataObj) {
  //     if (postDataObj[key] === null || postDataObj[key] === undefined || postDataObj[key] === "") {
  //       this.setState({ warning: true});
  //       this.stopLoading()
  //       return;
  //     }
  //   }
 
  //   try {
  //     let response = await fetch (urls.REGISTER, {
  //                   headers: headers,
  //                   method: 'POST',
  //                   body: post_data
  //               })
  //     let password = this.state.dealer_password
  //     console.log("************ response ******",response)

  //     console.log("============= insert registration info =======", response);
  //     this.stopLoading()

  //     if (response.email?.includes("A user is already registered with this e-mail address.") ||
  //     response.username?.includes("A user with that username already exists.")){
  //       this.setState({ warning1: true});
  //     }
  //     else if (response.password1?.includes("This password is too short. It must contain at least 8 characters.") ) {
  //       this.setState({ warning2: true});          
  //      }
  //     else if (response.non_field_errors?.includes( "The two password fields didn't match.")){
  //       this.setState({ warning3: true});
  //     }
  //     else if (!response || response === false){
  //       this.setState({ error: true}); //commented out to avoid alerting user of server error due to email
  //       // this.setState({success: true});
  //       // Delay before reload to allow user to see the alert
  //       // setTimeout(() => {
  //       //   // window.location.reload();
  //       //   this.props.navigate("/");
  //       // }, 1000); // 3 seconds delay
        
  //     }
  //     else {
  //       this.setState({success: true});

  //       // Delay before reload to allow user to see the alert
  //       // setTimeout(() => {
  //       //   window.location.reload();
  //       // }, 2000); // 2 seconds delay
  //     }
  //   } catch (error) {
  //     console.error("Error in Admin/Dealer Registration:", error);
  //     this.stopLoading()
  //     this.setState({ error: true}); //commented out to avoid alerting user of server error due to email
  //     // alert("An error occurred while Registration. Please try again later.");
  //   }
  // }

  InsertDealerRegistrationInfo = async () => {
    this.startLoading();
  
    let headers = {
        'content-type': 'application/json'
    };
  
    let post_data = this.jsonData();
    console.log("post_data in insertCreateTicketInfo:", post_data);
  
    let postDataObj = JSON.parse(post_data);
  
    for (const key in postDataObj) {
        if (postDataObj[key] === null || postDataObj[key] === undefined || postDataObj[key] === "") {
            this.setState({ warning: true });
            this.stopLoading();
            return;
        }
    }
  
    try {
        let response = await fetch(urls.REGISTER, {
            headers: headers,
            method: 'POST',
            body: post_data
        });
  
        let jsonResponse = await response.json();  //  Parse JSON response
        console.log("Response from server:", jsonResponse);
  
        this.stopLoading();
  
        if (response.status === 400) {
            // ✅ Handle old error format (Django-style field errors)
            let errors = [];
  
            if (jsonResponse.error && Array.isArray(jsonResponse.error)) {
               // errors = jsonResponse.error.map(err => err.message);
                errors = "email address already in use! please try with another email address";
            } else {
                // Loop through old Django-style field errors
                for (const field in jsonResponse) {
                    if (Array.isArray(jsonResponse[field])) {
                        errors.push(...jsonResponse[field]);  // Collect all messages
                    }
                }
            }
  
            console.log("Errors:", errors);
  
            if (errors.includes("A user with that username already exists.")) {
                this.setState({ warning1: true });
            } else if (errors.includes("This password is too short. It must contain at least 8 characters.")) {
                this.setState({ warning2: true });
            } else if (errors.includes("The two password fields didn't match.")) {
                this.setState({ warning3: true });
            }else if (errors?.includes("The password is too similar to the username.")) {
              
              this.setState({success:true})
                setTimeout(() => {
                  // window.location.reload();
                  this.props.navigate("/");
                }, 1800); // 1 seconds delay
            }
             else {
                this.setState({ error: true });  // Generic error handling
            }
        } else if (jsonResponse.key) {
            //  Successful registration (new response format)
            this.setState({ success: true });
  
            console.log("User registered successfully. API Key:", jsonResponse.key);
  
            //  Store the API key if needed
            localStorage.setItem("auth_token", jsonResponse.key);
  
            //  Redirect user after success
            setTimeout(() => {
                this.props.navigate("/");
            }, 2000);
        } else {
            this.setState({ error: true });
        }
    } catch (error) {
        console.error("Error in Admin/Dealer Registration:", error);
        this.stopLoading();
        this.setState({ error: true });
    }
  };

  startLoading = () => {
    console.log("startloading")

    this.setState({ open_progress_bar: true })
  }

  stopLoading = () => {
      this.setState({ open_progress_bar: false })
  }

  togglePasswordVisiblity = () => {
    this.setState(prevState => ({
      passwordShown: !prevState.passwordShown
    }));
    };

  toggleConfirmPasswordVisiblity = () => {
    this.setState(prevState => ({
      confPasswordShown: !prevState.confPasswordShown
    }));
    };

  render(){
    const {warning, warning1, warning2, warning3, success, error, passwordShown, confPasswordShown} = this.state;
      return (
        <div>
            <div style={{ display: 'flex', backgroundColor: '#003366', color:"white", padding:'8px',  }}>
            <Link to="/" style={{color:'#fff', textDecoration: 'none', fontSize:'18px'}}><img src={BackArrow} alt="Back arrow" style={{ marginRight: '8px', borderRadius:'35px', width:'30px' }} /></Link>
              <em>Register New Admin/Dealer User</em>&emsp; &gt;&gt;      
            </div>
                    
                <div className="bordered-div" >
                <div>
                          {warning ? (
                                <Alert severity="warning" style={{ marginLeft:'7%', width: "480px" }}>Please fill all the required fields!</Alert>
                            ) :warning1 ? (
                              <Alert severity="warning" style={{ marginLeft:'7%', width: "480px" }}>User name or email already exist!</Alert>
                            ) :warning2 ? (
                              <Alert severity="warning" style={{ marginLeft:'7%', width: "480px" }}>password is too short! enter minimum 8 characters.</Alert>
                            ) :warning3 ? (
                             <Alert severity="warning" style={{ marginLeft:'7%', width: "480px" }}>The two password fields didn't match!</Alert>
                            ) : error ? (
                                <Alert severity="error" style={{ marginLeft:'7%', width: "480px" }}>Server Error! New Admin was not registered!</Alert>
                            ) : success ? (
                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success" style={{ marginLeft:'7%', width: "480px" }}>
                                    "Great! The new Admin is now registered."
                                </Alert>
                            ) : null}
                      </div><br/>
                  <div className='form-group'>
                      <label htmlFor="user_name">User name <span style={{color:'red'}}>*</span>: &nbsp;</label>
                      <input
                          type="text"
                          id="user_name"
                          name="user_name"
                          required
                          style={{ width: '350px', height: '0.7cm' }}
                          // placeholder=" fill upto 32 characters only (including spaces)"
                          // placeholder="Enter your user name"
                          value={this.state.user_name}
                          onChange={(evt) => this.setState({ user_name: evt.target.value })}
                        />
                  </div>
                  
                  <div className='form-group'>
                      <label htmlFor="dealer_email"> Email <span style={{color:'red'}}>*</span> : &nbsp;</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          required
                          style={{ width: '350px', height: '0.7cm' }}
                          value={this.state.dealer_email}
                          onChange={(evt) => this.setState({ dealer_email: evt.target.value })}
                        />
                  </div>
                 
                  <div className='form-group'>
                      <label htmlFor="dealer_password" > Password <span style={{color:'red'}}>*</span> : &nbsp;</label>
                      <div style={{ position: "relative", display: "inline-block", width: "350px" }}>
                        <input
                          type={passwordShown ? "text" : "password"}
                          id="password"
                          name="password"
                          required
                          style={{ width: '350px', height: '0.7cm' }}
                        
                          value={this.state.dealer_password}
                          onChange={(evt) => this.setState({ dealer_password: evt.target.value })}
                        />
                        <span
                          style={{
                            position: "absolute",
                            right: "1px",
                            top: "55%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                          }}
                        >
                          <img onClick={this.togglePasswordVisiblity} src={passwordEye} alt="password-eye" width='25' height='25' />
                        </span>
                      </div>
                  </div>
                  
                  <div className='form-group'>
                      <label htmlFor="conf_dealer_pass" > Confirm password <span style={{color:'red'}}>*</span> : &nbsp;</label>
                      <div style={{ position: "relative", display: "inline-block", width: "350px" }}>
                      <input
                          type={confPasswordShown ? "text" : "password"}
                          id="conf_dealer_pass"
                          name="conf_dealer_pass"
                          required
                          style={{ width: '350px', height: '0.7cm' }}
                          
                          value={this.state.conf_dealer_pass}
                          onChange={(evt) => this.setState({ conf_dealer_pass: evt.target.value })}
                        />
                        <span
                        style={{
                          position: "absolute",
                          right: "1px",
                          top: "55%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                        }}
                      >
                        <img onClick={this.toggleConfirmPasswordVisiblity} src={passwordEye} alt="password-eye" width='25' height='25' />

                      </span>
                        </div>
                  </div>
                  <div className='form-group'>
                      <label htmlFor="first_name" > First name <span style={{color:'red'}}>*</span> : &nbsp;</label>
                      <input
                          type="text"
                          id="first_name"
                          name="first_name"
                          required
                          style={{ width: '350px', height: '0.7cm' }}
                          
                          value={this.state.first_name}
                          onChange={(evt) => this.setState({ first_name: evt.target.value })}
                        />
                  </div>
                  <div className='form-group'>
                      <label htmlFor="last_name" > Last name <span style={{color:'red'}}>*</span> : &nbsp;</label>
                      <input
                          type="text"
                          id="last_name"
                          name="last_name"
                          required
                          style={{ width: '350px', height: '0.7cm' }}
                          
                          value={this.state.last_name}
                          onChange={(evt) => this.setState({ last_name: evt.target.value })}
                        />
                  </div>
                  <div className='form-group'>
                      <label htmlFor="mob_num" > Mobile no. <span style={{color:'red'}}>*</span>  :&nbsp;</label>
                      <div style={{display:'flex', flexDirection:'column'}}>
                      <input
                          type="tel"
                          id="mob_num"
                          name="mob_num"
                          required
                          style={{ width: '350px', height: '0.7cm' }}
                          value={this.state.mob_num}
                          // onChange={(evt) => this.setState({ mob_num: evt.target.value })}
                          onChange={(evt) => {
                            const value = evt.target.value.replace(/\D/g, ""); // Only allow numbers
                            if (value.length <= 10) {
                              this.setState({ mob_num: value });
                            }
                          }}
                        />
                        {this.state.mob_num.length > 0 && this.state.mob_num.length !== 10 && (
                          <p style={{ color: 'red', fontSize:'14px' }}>Mobile number must be exactly 10 digits</p>
                        )}
                        </div>
                  </div>
                </div>
            
            <div style={{ width: '135px', height: '0.6cm', marginLeft:'170px', marginTop:'8px', marginBottom: '100px'  }}>
              {/* <Link to="/all_tech_issues"> */}
              <button id='rowsPerPageButton' 
              onClick={this.InsertDealerRegistrationInfo}
              > Register</button>
              {/* Backdrop with CHM logo Progress */}
              <Backdrop open={this.state.open_progress_bar}>
                <div className="custom-spinner">
                  <div className="circle"></div>
                  <div className="circle tilted"></div>
                  <img src={WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
                </div>
              </Backdrop>
              {/* </Link> */}
            </div>
            <div id="copyright-footer">
                <p style={{fontSize:'12px'}}>
                <em>&copy; 2024 Neudeep Technologies. All rights reserved.</em>
                </p>
              </div>
        </div>
      )
  }
}


export default withNavigate(DealerRegistration);